import HttpClient from '../../../services/http-client';
import { Pagination } from '../../../../model/pagination';
import { IAgreementPagedRequest } from '../../../../model/apm/agreement/request/agreement-paged-request';
import { IAgreementAddEditRequest } from '../../../../model/apm/agreement/request/agreement-add-edit-request';
import { IAgreementListResponse } from '../../../../model/apm/agreement/response/agreement-list-response';
import { IAgreementResponse } from '../../../../model/apm/agreement/response/agreement-response';

const defaultPath = 'Agreement';

// Paginação 0-based; a API limita PageSize a 100
const list = async (params: IAgreementPagedRequest): Promise<Pagination<IAgreementListResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}`,
        params: {
            Term: params.term || undefined,
            Year: params.year,
            Page: params.page,
            PageSize: params.pageSize,
        }
    }).then((response) => Object.assign(new Pagination<IAgreementListResponse>(), response.data));
};

const getById = async (id: number): Promise<IAgreementResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}`
    }).then((response) => response.data);
};

const add = async (params: IAgreementAddEditRequest): Promise<IAgreementResponse> => {
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}`,
        data: params
    }).then((response) => response.data);
};

const edit = async (id: number, params: IAgreementAddEditRequest): Promise<IAgreementResponse> => {
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}`,
        data: params
    }).then((response) => response.data);
};

const remove = async (id: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}`
    });
};

const AgreementAppService = { list, getById, add, edit, remove };
export default AgreementAppService;
